import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./slice/counterSlice"; // Importamos el reducer
import InboundSlice from "./slice/InboundSlice";

export const store = configureStore({
  reducer: {
    counter: counterReducer, // Agregamos más reducers aquí si es necesario
    inbound: InboundSlice, 
  },
});

export default store;
